import { $ } from '@situation/setdesign.util';

const COMPACT_SELECTOR = '.tc-month-carousel--compact';
const ACTIVE_CLASS = 'fc-event--active';

// Matches the aria-label set on each day by the month-carousel-compact eventRender
const markActiveDay = ($root, date) => {
    $root.find('.fc-event').removeClass(ACTIVE_CLASS);

    if (date) {
        $root.find(`.fc-event[aria-label="${date.format('MMMM Do YYYY')}"]`).addClass(ACTIVE_CLASS);
    }
};

$(document).one('TicketCalendar.init', (e, TicketCalendar, $on) => {
    $on(TicketCalendar.FILTER_DEFAULTS, (defaults) => {
        defaults.update({
            // set to the $tc-theme-name sass variable
            theme: 'damnyankees-theme',
            'selected-date-performances': {
                buttonClass: '',
                buttonLinkTextOverride:
                    'Select Seats <span class="icon icon-use"><svg><use xlink:href="#icon-chevron"></use></svg></span>',
            },
            fullcalendar: {
                prevIcon: '<span class="icon icon-use"><svg><use xlink:href="#icon-chevron"></use></svg></span>',
                nextIcon: '<span class="icon icon-use"><svg><use xlink:href="#icon-chevron"></use></svg></span>',
                // Re-apply the active day after initial render and month navigation
                eventAfterAllRender(view) {
                    const $root = $(view.el).closest(COMPACT_SELECTOR);
                    if (!$root.length) {
                        return;
                    }

                    const vm = $root[0].__vue__;
                    markActiveDay($root, vm && vm.selectedDate);
                },
            },
        });
    });

    // Day clicks don't re-render the calendar, so update the active day directly
    $on('select-event', (event) => {
        if (event && event.start) {
            markActiveDay($(COMPACT_SELECTOR), event.start);
        }
    });
});
